import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'faq-container',
	template: require('./faq-container.component.html'),
})
export class FaqContainerComponent {
	public isNewFaqEnabled: boolean = AppSettings.isNewFaqEnabled;
}
